import { HYDRATE } from 'next-redux-wrapper';

import config, { Locale } from '../../config';
import { BROWSER_NAVIGATION_BUTTON_PRESSED, CACHE_DATA, LOCALE_SET } from '../action-types/common.action-types';

const countryLanguage = config.get('countryLanguage');
const country = config.get('country');

export type CacheDataType = {
  [cacheKey: string]: any;
};

export type CommonDataReducer = {
  cache: CacheDataType;
  browserNavigationButtonPressed?: boolean;
  locale: Locale;
};

const initialState: CommonDataReducer = {
  cache: {},
  browserNavigationButtonPressed: false,
  locale: `${countryLanguage}-${country}` as Locale,
};

const cacheReducer = (state = initialState, action) => {
  switch (action.type) {
    case HYDRATE: {
      // CRITICAL: Preserve client locale during navigation
      // Only merge cache, don't overwrite locale from SSR (which has default locale during client-side nav)
      // Client locale is the source of truth (set by user and stored in cookie)
      return {
        ...state,
        cache: {
          ...state.cache,
          ...action.payload.commonData?.cache,
        },
        // Keep client's locale, browserNavigationButtonPressed
      };
    }
    case CACHE_DATA: {
      return {
        ...state,
        cache: {
          ...state.cache,
          [action.cacheKey]: action.data,
        },
      };
    }
    case BROWSER_NAVIGATION_BUTTON_PRESSED: {
      return {
        ...state,
        browserNavigationButtonPressed: action.isPressed,
      };
    }
    case LOCALE_SET: {
      return {
        ...state,
        locale: action.locale,
      };
    }
    default: {
      return state;
    }
  }
};

export default cacheReducer;
